var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pointer active",on:{"click":_vm.OnCreateWord}},[_c('el-button',{attrs:{"type":"primary"}},[_vm._v("下载到本地")]),_c('el-progress',{staticStyle:{"margin-top":"8px"},attrs:{"percentage":_vm.percentage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }